import dayjs from "dayjs";
import { array, date, object, string } from "yup";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  // Left empty on purpose: the backend falls back to the purchase payment's own
  // note, so an untouched field mirrors the paying outlet's wording.
  note: "",
  outletChartOfAccount: null,
  // One row per discount on the source payment, built from it at load time.
  discountAccounts: [],
};

export const VALIDATION_SCHEMA = object().shape({
  transactionDate: date().required("Harus diisi"),
  note: string().nullable(),
  outletChartOfAccount: object().nullable().required("Harus diisi"),
  // Every discount row on the source must be mapped exactly once; the backend
  // rejects a partial mapping, so the requirement is enforced per row here.
  discountAccounts: array().of(
    object().shape({
      outletChartOfAccount: object().nullable().required("Harus diisi"),
    })
  ),
});

/**
 * The discount rows the hub has to map, flattened out of the source payment.
 *
 * Discounts hang off each invoice allocation, but the convert payload wants one
 * flat list keyed by the source row id, so the invoice is carried along only as
 * a label for the operator.
 */
export const buildDiscountAccountRows = (purchaseInvoicePayments) =>
  (purchaseInvoicePayments ?? []).flatMap((purchaseInvoicePayment) =>
    (purchaseInvoicePayment.discountAccounts ?? []).map((discountAccount) => ({
      purchaseInvoicePaymentDiscountOutletChartOfAccountId: discountAccount.id,
      purchaseInvoiceReferenceNumber:
        purchaseInvoicePayment.purchaseInvoice?.referenceNumber ?? "-",
      sourceOutletChartOfAccount: discountAccount.outletChartOfAccount ?? null,
      amount: discountAccount.amount,
      outletChartOfAccount: null,
    }))
  );
